import { Cidade } from 'common/types/Cidade'
import GenericService from '@/shareds/GenericService'
import { ParametrosDeBusca } from 'common/types/Busca'
import { Pagina, Paginacao } from 'common/types/paginacao'

export const PATH_CIDADE = '/cidades'

class CidadeService extends GenericService<Cidade, unknown> {
    constructor() {
        super(PATH_CIDADE)
    }

    async find(_params?: ParametrosDeBusca): Promise<Cidade[]> {
        throw new Error('Endpoint usa dados paginados, favor utilizar `findPage`')
    }

    async findPage(params?: ParametrosDeBusca & Partial<Paginacao>) {
        const result = await this.axios.get<Pagina<Cidade>>(this.route, {
            params,
        })
        return result.data
    }
}

export default new CidadeService()
